import { ContactPermission } from '@reducers/data/shareStatuses/contacts';
import Contact from './Contact';

export class SharedContact extends Contact {
  sharerIsSelf: boolean;
  sharerDisplayName: string;
  sharedPublicly: boolean;
  publicPermissions: ContactPermission[];
  wasSharedDirectly: boolean;

  constructor(props: any = {}) {
    super(props);

    this.id = props.uuid || this.id;
    this.isSharedContact = true;
    this.sharerIsSelf = props.sharer?.is_self || props.sharerIsSelf;
    this.sharerDisplayName = props.sharer?.display_name || props.sharerDisplayName;
    this.sharedPublicly = props.shared || props.sharedPublicly;
    this.publicPermissions = props.permissions || props.publicPermissions;
    this.wasSharedDirectly = props.wasSharedDirectly;
  }
}
